import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import CustomerTableRecords from '../CustomerTableRecords';

const AwaitingApprovalCustomers = () => (
  <CustomerTableRecords defaultUrl={AdminRouteName.awaitingApprovedCustomersRoute} toggleStorageId="all_customer-table-col" hasNameAndImage permissionName="can-view-all-customer-tab" tabStatus="awaiting_approval" />
);
export default AwaitingApprovalCustomers;
